import { render, staticRenderFns } from "./MySpaceUsers.vue?vue&type=template&id=18c5cd78&"
import script from "./MySpaceUsers.vue?vue&type=script&lang=js&"
export * from "./MySpaceUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports